<div class="p-3">

</div>

<p-table [value]="categoryData" [loading]="loading">
    <ng-template pTemplate="body" let-category>
        <tr (click)="openCategory(category)">
            <td>
                <div class="grid">
                    <div class="col-7 pb-0">
                        <div class="grid">
                            <div class="col-12 py-0">
                                <label class="text-bold">{{category.instrumentTypeDisplayString}}</label>
                            </div>
                            <div class="col-12 text-sm py-0">
                                <i [ngClass]="category.statusIconWithColor" style="font-size:small"></i>
                                <label> {{category.statusText}}</label>
                            </div>
                            <div class="col-12 text-sm py-0">
                                <label>{{category.nextWorklistText}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 pb-0">
                        <div class="grid text-sm text-right">
                            <div class="col-12 py-0">
                                <label>Running: </label>
                                <label class="text-green-500">{{category.numRunning}}</label>
                            </div>
                            <div class="col-12 py-0">
                                <label>Idle: </label>
                                <label class="text-blue-500">{{category.numIdle}}</label>
                            </div>
                            <div class="col-12 py-0">
                                <label>Error: </label>
                                <label class="text-red-500">{{category.numError}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-1 pb-0">
                        <div class="h-full">
                            <i class="pi pi-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>